import { memo, useCallback } from "react";

// UI
import { DatePicker } from "ui/components/DatePicker";
import DriverDropdown from "ui/components/Dropdown/DriverDropdown/DriverDropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { TextArea } from "ui/components/TextField/TextArea";

import { getStatusField } from "../fields";
import { VehicleStatusFieldsProps } from "../types";

/**
 * Aktivno – Interno. Odgovara `VehicleStatusInternalDetail` na backendu — vozač je obavezan.
 *
 * Vozač se bira isto kao kod premještaja — iz popisa vozača vozila. Je li iza njega
 * korisnik aplikacije ili kontakt iz imenika, odlučuje se pri unosu vozača.
 */
const VehicleStatusInternalFields: React.FC<VehicleStatusFieldsProps> = (props) => {
  const { status, vehicleId, values, errors, onChange } = props;

  const driverField = getStatusField(status, "driver");
  const validFromField = getStatusField(status, "validFrom");
  const validUntilField = getStatusField(status, "validUntil");
  const noteField = getStatusField(status, "note");

  const handleDriverChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onChange({ driverId: item.value || null });
    },
    [onChange]
  );

  const handleDateChange = useCallback(
    (name: string, value: Date | null) => {
      onChange({ [name]: value });
    },
    [onChange]
  );

  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      onChange({ [name]: value });
    },
    [onChange]
  );

  return (
    <div className="grid grid-cols-2 gap-3">
      {driverField && (
        <div className="col-span-2">
          <DriverDropdown
            name="driverId"
            label={driverField.label}
            placeholder="Odaberite vozača"
            vehicleId={vehicleId}
            value={values.driverId}
            onChange={handleDriverChange}
            error={errors.driverId}
            required={driverField.required}
            width="full"
          />
        </div>
      )}

      {validFromField && (
        <div>
          <DatePicker
            name="validFrom"
            label={validFromField.label}
            placeholder={validFromField.label}
            value={values.validFrom}
            onChange={handleDateChange}
            error={errors.validFrom}
            required={validFromField.required}
            width="full"
          />
        </div>
      )}

      {validUntilField && (
        <div>
          <DatePicker
            name="validUntil"
            label={validUntilField.label}
            placeholder={validUntilField.label}
            value={values.validUntil}
            onChange={handleDateChange}
            error={errors.validUntil}
            required={validUntilField.required}
            width="full"
          />
        </div>
      )}

      {/* Svrha zaduženja se piše u par rečenica, ne u jedan redak. */}
      {noteField && (
        <div className="col-span-2">
          <label className="block text-sm mb-2 font-medium leading-6 text-[#344054]">
            {noteField.label}
            {noteField.required && <span className="text-red-500"> *</span>}
          </label>
          <TextArea
            name="note"
            placeholder={noteField.label}
            value={values.note}
            onChange={handleTextChange}
            error={errors.note}
            rows={6}
            size="full"
          />
        </div>
      )}
    </div>
  );
};

export default memo(VehicleStatusInternalFields);
